import React__default from 'react';
import { UltimateSpecialOffers } from '../../../innerComponents/UltimateSpecialOffers/src/UltimateSpecialOffers.js';
import '../../../innerComponents/UltimateSpecialOffers/src/constants/labels.js';

const SpecialOffers = (props) => {
    return React__default.createElement(UltimateSpecialOffers, { ...props });
};

export { SpecialOffers };
//# sourceMappingURL=SpecialOffers.js.map
